import {Box, List, ListItem, ListItemIcon, ListItemText, Typography} from '@mui/material';
import {CSVExport} from 'components/buttons';
import AppIconButton from 'components/buttons/AppIconButton';
import {useBoardRedux, useGetAllItemStatusesByBoardId, useSprintsRedux, useUploadItemDataForBoardAPI} from 'hooks';
import {DocumentDownload, DocumentUpload} from 'iconsax-react';
import {SprintStatus} from 'models/sprint.model';
import {useEffect, useMemo, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useParams} from 'react-router-dom';
import {setReloadTheStatusItemsById} from 'store/itemStatues';
import {CustomFile} from 'types';
import {AppUploadExcelCsv} from 'views/board/UploadCsv';

export const BoardFilesSetting = () => {
    const {selectedBoard, selectedDefaultForm} = useBoardRedux();
    const {boardId} = useParams();
    const dispatch = useDispatch();
    const {selectedSprint} = useSprintsRedux();
    const {getAllItemStatuses, getAllStatusessResponse} = useGetAllItemStatusesByBoardId();
    const [loading, setLoading] = useState(false);
    const dataObj = useMemo(() => selectedDefaultForm?.formFieldsData ?? [], [selectedDefaultForm?.formFieldsData]);
    const [uploadDataSelectedStatus, setUploadDataSelectedStatus] = useState<string>('');
    const {uploadItemDataForBoard, uploadItemDataForBoardLoading, uploadItemDataForBoardResponse} =
        useUploadItemDataForBoardAPI();
    const [uploadExcelFileDialog, setUploadExcelFileDialog] = useState(false);
    const handleFileUpload = (file: CustomFile, selectedStatus: string, selectedField: string) => {
        setLoading(true);
        if (selectedBoard) {
            const sprintId = selectedSprint?.sprintStatus === SprintStatus.All ? undefined : selectedSprint?.id;
            uploadItemDataForBoard(
                file as File,
                selectedDefaultForm.formFieldsData,
                selectedStatus,
                selectedField,
                sprintId,
            );
            setUploadDataSelectedStatus(selectedStatus);
        }
    };
    useEffect(() => {
        if (boardId || selectedBoard?.slug) {
            getAllItemStatuses({
                variables: {
                    boardSlug: boardId ?? selectedBoard?.slug ?? '',
                },
            });
        }
    }, []);

    useEffect(() => {
        if (!uploadItemDataForBoardLoading && uploadItemDataForBoardResponse) {
            if (selectedBoard && selectedBoard.id) {
                setLoading(false);
                setUploadExcelFileDialog(false);
                dispatch(setReloadTheStatusItemsById(uploadDataSelectedStatus));
            }
        }
    }, [uploadItemDataForBoardLoading, uploadItemDataForBoardResponse]);

    return (
        <Box height={'calc(100vh - 180px)'} overflow={'auto'} px={2} py={3}>
            <Typography variant="h5" mb={2}>
                File Transfer Settings
            </Typography>

            <List sx={{width: '100%', bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1}}>
                {/* Upload Feature */}
                <ListItem
                    secondaryAction={
                        <AppIconButton onClick={() => setUploadExcelFileDialog(true)}>
                            <DocumentUpload />
                        </AppIconButton>
                    }
                >
                    <ListItemIcon>
                        <DocumentUpload color="primary" />
                    </ListItemIcon>
                    <ListItemText primary="Upload File" secondary="Import files or data into the board." />
                </ListItem>

                {/* Download Template Feature */}
                <ListItem
                    secondaryAction={
                        <CSVExport
                            title="Download Template"
                            icon={
                                <AppIconButton>
                                    <DocumentDownload />
                                </AppIconButton>
                            }
                            data={[]}
                            headers={dataObj.map((field: any) => field.title)}
                            filename={`${selectedBoard?.title ?? 'Board'}-template`}
                        />
                    }
                >
                    <ListItemIcon>
                        <DocumentDownload color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        primary="Download Template"
                        secondary="Get a structured CSV template to fill out and upload."
                    />
                </ListItem>
            </List>
            {uploadExcelFileDialog && (
                <AppUploadExcelCsv
                    itemStatues={getAllStatusessResponse ?? []}
                    isLoading={loading}
                    onClose={() => setUploadExcelFileDialog(false)}
                    open={true}
                    title={'Itemdata uploads'}
                    onUpload={handleFileUpload}
                    key={'Itemdata uploads'}
                    onFinalUpload={() => {}}
                />
            )}
        </Box>
    );
};

export default BoardFilesSetting;
